<template>
  <div class="step">
    <h2>{{step}}</h2>
    <div class="pic" :style="{backgroundImage: 'url('+picStr+')'}"></div>
    <div class="text-content">
       <p  v-for="(item, i) in textArr" :key="i" class="text">{{item}}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'StepPic',
  props: {
    step: String,
    picStr: String,
    text: String
  },
  data () {
    return {
      textArr: [],
      text_: this.text
    }
  },
  methods: {
    breakUpStr () {
      if (this.text_.indexOf('&&')) {
        this.textArr = this.text_.split('&&')
      } else {
        this.textArr.push(this.text_)
      }
    }
  },
  watch: {
    text (newValue) {
      this.text_ = newValue
      this.breakUpStr()
    }
  },
  mounted () {
    this.breakUpStr()
  }

}
</script>
<style lang="stylus" scoped>
  h2
    font-size 20px;
    color #333333;
    text-align center;
    height 12vh;
    line-height 14.26vh;
  .pic
    width calc(55.47vh / 1.32)
    height 55.47vh;
    background-repeat no-repeat;
    background-size contain;
    background-position center center;
    margin 0 auto;
  .text-content
    padding-top 5vh
    width calc(55.47vh / 1.32)
    margin 0 auto
  p
    font-size 16px;
    font-size #333333;
    text-align center;
    line-height 20px;
</style>


// WEBPACK FOOTER //
// src/components/StepPic/StepPic.vue